import {Endpoint, Process} from '../../types-aspera';

/** One process row as the tables show it: the free-form `data` JSON read once, here, not in the template. */
export interface ProcessRow {
  id: string;
  kind: string;
  state: string;
  message?: string | null;
  startDate: string;
  endDate?: string | null;
  /** The file's path on the share, once the worker confirmed it. */
  remotePath: string | null;
  /** Where it came from (s3://...). */
  sourceUri: string | null;
  percent: number | null;
  /** Set when the transfer left from a fixed egress address. */
  egressIp: string | null;
}

export function toProcessRow(process: Pick<Process, 'id' | 'kind' | 'state' | 'message' | 'data' | 'startDate' | 'endDate'>): ProcessRow {
  const data = parseData(process.data);
  return {
    id: process.id,
    kind: process.kind,
    state: process.state,
    message: process.message,
    startDate: process.startDate,
    endDate: process.endDate,
    remotePath: stringOrNull(data['remotePath']),
    sourceUri: stringOrNull(data['sourceUri']),
    percent: typeof data['percent'] === 'number' ? data['percent'] : null,
    egressIp: stringOrNull(data['egressIp']),
  };
}

/** What the "Delivers" column says: an endpoint without `upload` takes no exports in this environment. */
export function deliveryLabel(endpoint: Pick<Endpoint, 'upload'>): string {
  return endpoint.upload ? `to ${endpoint.upload.remoteRoot}` : 'not in this environment';
}

function parseData(data: unknown): Record<string, unknown> {
  // AWSJSON reaches the client as the JSON text of the data map (verified against the sannies API, 2026-10-19):
  // parsed once here. Anything malformed shows as an empty row rather than breaking the table.
  if (typeof data !== 'string' || !data) {
    return {};
  }
  try {
    const parsed = JSON.parse(data);
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
}

function stringOrNull(value: unknown): string | null {
  return typeof value === 'string' && value ? value : null;
}
